import * as actions from './actions';
import * as reactions from './reactions';
import * as reducers from './reducers';
import * as selectors from './selectors';

export * from './constants';

export default {
  // fetch session
  init: (store) => store.doReadUserSession(),
  name: 'user',
  ...actions,
  ...reactions,
  ...reducers,
  ...selectors,
};
